const activeNav = () => {
    const navList = document.getElementById('vehicleType');
    navList.classList.add('active');
};
export default activeNav;